import { ArrowUpRight, CheckCircle, WarningCircle } from "@phosphor-icons/react";
import { Link, Outlet } from "react-router-dom";
import { Brand } from "../components/Brand";
import { Button } from "../components/ui/Button";
import { DISCLAIMER } from "../config/application";
export function PublicLayout() {
  return (
    <div className="min-h-screen bg-[#0B0D0E] text-white">
      <div className="app-shell">
        <header className="liquid-nav sticky top-0 z-30 border-b border-white/[.09]">
          <div className="mx-auto flex max-w-[1400px] items-center justify-between gap-5 px-5 py-4 sm:px-8">
            <Brand />
            <nav className="hidden items-center rounded-full border border-white/[.09] bg-white/[.035] p-1.5 shadow-[inset_0_1px_0_rgba(255,255,255,.06)] md:flex">
              <a className="nav-pill" href="/#how-it-works">Process</a>
              <a className="nav-pill" href="/#what-we-check">Coverage</a>
              <a className="nav-pill" href="/#privacy">Data handling</a>
            </nav>
            <div className="flex items-center gap-3">
              <span className="hidden items-center text-[.66rem] font-bold uppercase tracking-[.12em] text-[#77807B] xl:flex">
                Low Volume Mixed
              </span>
              <Link
                to="/rejection-check"
                aria-label="Analyze an A2P rejection code"
                className="rejection-nav-action"
              >
                <WarningCircle size={18} weight="fill" />
                <span className="hidden lg:inline">Decode a rejection</span>
                <span className="hidden sm:inline lg:hidden">Declined?</span>
              </Link>
              <Button className="hidden sm:inline-flex" onClick={() => window.location.assign("/assessment/new")}>
                Start quest
              </Button>
            </div>
          </div>
        </header>
        <Outlet />
        <footer className="site-footer border-t border-white/[.08] px-5 pb-7 pt-5 sm:px-8 sm:pt-8">
          <div className="mx-auto max-w-[1400px]">
            <section className="footer-cta liquid-glass overflow-hidden rounded-[30px] border border-white/[.1] px-6 py-8 sm:px-9 sm:py-10 lg:px-12 lg:py-12">
              <div className="grid items-end gap-8 lg:grid-cols-[1fr_auto]">
                <div>
                  <p className="eyebrow">Your next checkpoint</p>
                  <h2 className="mt-4 max-w-4xl font-display text-[2.25rem] font-medium leading-[1.02] tracking-[-.045em] text-[#F3F6F4] sm:text-[3.5rem] lg:text-[4.2rem]">
                    Ready to clear the path to carrier review?
                  </h2>
                  <p className="mt-5 max-w-2xl text-sm leading-7 text-[#89918D] sm:text-base">
                    Start the readiness quest before submission, or decode a rejection into a focused correction plan.
                  </p>
                </div>
                <div className="flex flex-col gap-3 sm:flex-row lg:flex-col">
                  <Link to="/assessment/new" className="footer-action footer-action-primary">
                    Start readiness quest <ArrowUpRight size={18} weight="bold" />
                  </Link>
                  <Link to="/rejection-check" className="footer-action">
                    Decode a rejection <ArrowUpRight size={18} weight="bold" />
                  </Link>
                </div>
              </div>
              <div className="footer-signal-row mt-9">
                <span>Low Volume Mixed</span>
                <span>DBA optional</span>
                <span>12 focused checks</span>
                <span>Temporary by design</span>
              </div>
            </section>

            <div className="footer-directory grid gap-10 py-12 md:grid-cols-[1.35fr_.65fr_.65fr] lg:py-16">
              <div>
                <p className="max-w-md text-sm leading-7 text-[#737B77]">
                  A friendlier way to prepare Low Volume Mixed A2P campaigns—before submission or after a decline.
                </p>
                <div className="mt-7 inline-flex items-center gap-2 rounded-full border border-brand/20 bg-brand/[.045] px-3 py-2 text-[.65rem] font-bold uppercase tracking-[.12em] text-brand">
                  <CheckCircle size={15} weight="fill" /> Focused scope
                </div>
              </div>
              <div>
                <p className="footer-column-label">Product</p>
                <nav className="footer-links mt-5" aria-label="Footer product links">
                  <Link to="/assessment/new">Readiness checker <ArrowUpRight size={14} /></Link>
                  <Link to="/rejection-check">Rejection analyzer <ArrowUpRight size={14} /></Link>
                  <a href="/#what-we-check">Reviewer coverage <ArrowUpRight size={14} /></a>
                </nav>
              </div>
              <div>
                <p className="footer-column-label">Learn</p>
                <nav className="footer-links mt-5" aria-label="Footer information links">
                  <a href="/#how-it-works">Process <ArrowUpRight size={14} /></a>
                  <a href="/#privacy">Data handling <ArrowUpRight size={14} /></a>
                  <span>Low Volume Mixed only</span>
                </nav>
              </div>
            </div>

            <div className="footer-brand-mark">
              <Brand />
            </div>

            <div className="grid gap-5 border-t border-white/[.07] py-7 md:grid-cols-[auto_1fr] md:items-start md:gap-12">
              <p className="whitespace-nowrap text-xs font-semibold text-[#626965]">© 2026 A2bait</p>
              <p className="max-w-4xl text-xs leading-5 text-[#626965]">{DISCLAIMER}</p>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
